export default __webpack_public_path__ + "static/media/s-9.bdcfbb05.jpg";